import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { HttpRequestComponent } from 'src/app/shared/http-request/http-request.component';
import { LocalService, StatusWithId } from './local.service';
import { MachineDetail, PrintData, PrinterDetail } from 'src/app/entities/offline';

@Injectable({
  providedIn: 'root'
})
export class OfflineService {
  private offlineNameConfiguration = service_controllers_methods.offline.controller;
  private methodsConfiguration = service_controllers_methods.offline.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public isServiceAvailable(serviceUrl: string): Observable<StatusWithId> {
    return this.httpService.request_general_get_by_type(serviceUrl, "is-service-available", true);
  }

  public getPrinters(serviceUrl: string): Observable<PrinterDetail> {
    return this.httpService.request_general_get_by_type(serviceUrl, this.offlineNameConfiguration + this.methodsConfiguration.getPrinters, true);
  }

  public getLocalPrinters(serviceUrl: string): Observable<PrinterDetail> {
    return this.httpService.request_general_get_by_type(serviceUrl, this.offlineNameConfiguration + this.methodsConfiguration.getPrinters, true);
  }

  public getLocalMachines(serviceUrl: string): Observable<MachineDetail[]> {
    return this.httpService.request_general_get_by_type(serviceUrl, 'weight/get-serial-ports', true);
  }

  public getTemporaryFolder(serviceUrl: string): Observable<StatusWithId> {
    return this.httpService.request_general_get_by_type(serviceUrl, this.offlineNameConfiguration + this.methodsConfiguration.getTemporaryFolder, true);
  }

  public setPrint(serviceUrl: string, printData: PrintData, isShowSpinner = false): Observable<StatusWithId> {
    let body = {
      dt: printData
    };
    return this.httpService.request_general_post_by_service_type(serviceUrl, this.offlineNameConfiguration + this.methodsConfiguration.setPrint, body, isShowSpinner, false, false);
  }
}
